import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import messages from './messages/LicenseActivationPanel';

import LicenseContactPerson from './LicenseContactPerson';
import LicenseForm from './LicenseForm';
import LicenseInfo from './LicenseInfo';
import './styles/LicenseActivationPanel.scss';

import Button from '../../components/Button';

const propTypes = {
  currentLicense: PropTypes.object,
  licenseTypes: PropTypes.array,
  onActivate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  sellers: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  companyId: PropTypes.number,
};

const defaultProps = {
  currentLicense: null,
  licenseTypes: null,
  companyId: null,
};

class LicenseActivationPanel extends Component {
  constructor(props) {
    super(props);

    this.STAGE_CONFIRM = 'STAGE_CONFIRM';
    this.STAGE_CONTACT_PERSON = 'STAGE_CONTACT_PERSON';
    this.STAGE_FORM = 'STAGE_FORM';

    this.initialState = {
      contactPerson: null,
      license: null,
      stage: this.STAGE_FORM,
    };
    this.state = this.initialState
  }

  onLicenseFormSubmit = ({ license }) => {
    const { companyId } = this.props;
    license.data.company = { 'id': companyId };
    this.setState({ license, stage: this.STAGE_CONTACT_PERSON });
  }

  onContactPersonSelect = ({ contactPerson }) => {
    const license = this.state.license.clone();
    license.data.contactPerson = contactPerson;
    this.setState({ contactPerson, license, stage: this.STAGE_CONFIRM });
  }

  onContactPersonCancel = ({ contactPerson }) => {
    this.setState({ contactPerson, stage: this.STAGE_FORM });
  }

  onConfirmCancel = () => {
    this.setState({ stage: this.STAGE_CONTACT_PERSON });
  }

  onCancel = () => {
    const { license } = this.state;
    this.setState(this.initialState, () => this.props.onCancel({ license }));
  }

  onActivate = () => {
    const { license } = this.state;
    this.setState(this.initialState, () => this.props.onActivate({ license }));
  }

  get isUpgrade() {
    /* Helper to add clarity */
    return !this.isAdd;
  }

  get isAdd() {
    /* Helper to add clarity */
    const { currentLicense } = this.props;
    return !currentLicense;
  }

  get stage() {
    /* Helper to add clarity */
    return this.state.stage;
  }

  render = () => {
    const {
      currentLicense,
      companyId,
      licenseTypes,
      sellers,
      user } = this.props;
    const { contactPerson, license } = this.state;

    return (
      <div styleName='LicenseActivationPanel'>
        {this.isAdd && (
          <strong>
            <FormattedMessage {...messages.titleActivation} />
          </strong>
        )}
        {this.isUpgrade && (
          <React.Fragment>
            <strong>
              <FormattedMessage {...messages.titleUpgrade} />
            </strong>
            <p styleName='notice'>
              <FormattedMessage {...messages.upgradeWarning} />
            </p>
          </React.Fragment>
        )}

        <div styleName='padder' />

        {this.stage === this.STAGE_FORM && (
          <LicenseForm
            currentLicense={currentLicense}
            externalControls
            initialData={license}
            initialSellerId={user.id}
            isAdd={this.isAdd}
            isUpgrade={this.isUpgrade}
            licenseTypes={licenseTypes}
            onCancel={this.onCancel}
            onSubmit={this.onLicenseFormSubmit}
            sellers={sellers}
          >
            {({ onSubmit, onCancel, valid }) =>
              <div styleName='controls'>
                <Button
                  disabled={!valid}
                  id="license-form-submit-button"
                  onClick={onSubmit}
                >
                  <FormattedMessage { ...messages.submitFormAction } />
                </Button>
                <Button
                  id="license-form-cancel-button"
                  kind='tertiary'
                  onClick={onCancel}
                  color='grey'
                >
                  <FormattedMessage { ...messages.cancellationAction } />
                </Button>
              </div>
            }
          </LicenseForm>
        )}

        {this.stage === this.STAGE_CONTACT_PERSON && (
          <LicenseContactPerson
            companyId={companyId}
            initialContactPerson={contactPerson}
            onCancel={this.onContactPersonCancel}
            onSelect={this.onContactPersonSelect}
          />
        )}

        {this.stage === this.STAGE_CONFIRM && (
          <React.Fragment>
            <LicenseInfo
              license={license}
              visibleFields={license.data.continuous
                ? [
                  'seller.email',
                  'licenseType.name',
                  'license.priceNoVat',
                  'license.startDate',
                  'license.continuous',
                  'license.customerReference',
                  'contactPerson.name',
                ]
                : [
                  'seller.email',
                  'licenseType.name',
                  'license.priceNoVat',
                  'license.startDate',
                  'license.endDate',
                  'license.customerReference',
                  'contactPerson.name',
                ]
              }
            />
            <div styleName='padder' />
            <div styleName='controls'>
              <Button
                id='license-activation-confirm-yes-button'
                onClick={this.onActivate}
                color='green'
              >
                {this.isAdd && (
                  <FormattedMessage { ...messages.activationAction } />
                )}
                {this.isUpgrade && (
                  <FormattedMessage { ...messages.upgradeAction } />
                )}
              </Button>
              <Button
                id='license-activation-confirm-no-button'
                kind='tertiary'
                onClick={this.onConfirmCancel}
                styleName='back-button'
                color='grey'
              >
                <FormattedMessage { ...messages.backAction } />
              </Button>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

LicenseActivationPanel.propTypes = propTypes;
LicenseActivationPanel.defaultProps = defaultProps;

export default injectIntl(LicenseActivationPanel);
